import { UseLayout } from './type';

export const useLayout: UseLayout = ({ mode }) => {
  return {
    layout: mode === 'edit' ? 'vertical' : 'horizontal',
  };
};
